<div class="app-create-account" [class.welcome-message]="showWelcomeMessage()" [class.app-create-account--ia-mode]="iaModeMobile.active()">
  @if (saving()) {
  <div class="app-create-account__loading">
    <div class="app-create-account__loading-card">
      <aprova-loading-bar title="Confirmando sua conta..." />
    </div>
  </div>
  } @else if (showWelcomeMessage()) {
  <div class="app-create-account__welcome-box">
    <div class="app-create-account__welcome-box__body">
      <span class="app-create-account__welcome-box__hand" aria-hidden="true">👋</span>

      <div class="app-create-account__welcome-box__header">
        <p class="app-create-account__welcome-box__title">
          Que bom ter você com a gente!
        </p>
        <p class="app-create-account__welcome-box__subtitle">
          Vamos iniciar o seu cadastro de <strong>conta externa</strong>,
          exclusivo para você que é <strong>requerente</strong>.
        </p>
      </div>
    </div>

    <div class="app-create-account__welcome-box__actions">
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--secondary"
        (click)="redirectToLogin()"
      >
        Voltar
      </button>
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--primary"
        (click)="startAccountCreation()"
      >
        Continuar
      </button>
    </div>

    <div class="app-create-account__welcome-box__informative">
      <aprova-icon
        name="information-circle-solid"
        size="lg"
        color="#074A4E"
        class="info-icon"
      />
      <span>
        Se você trabalha nesta organização e precisa de
        <strong>conta interna</strong>, solicite ao administrador do sistema que
        lhe envie um convite para realizar o seu cadastro. Em caso de dúvidas,
        entre em contato com o nosso suporte.
      </span>
    </div>
  </div>
  } @else if (!accountCreated()) {
  <div class="app-create-account__content">
    <div class="app-create-account__heading">
      @if (iaModeMobile.active()) {
      <h2 class="app-create-account__title app-create-account__title--ia-mode" data-testid="createAccountMessageStepTitle">{{ currentStepTitle }}</h2>
      } @else {
      <h1 class="app-create-account__title">Criação de conta</h1>
      }
      @if (iaModeMobile.active() && allowUseCnpj() && currentStep === 0) {
      <a class="app-create-account__company-link" data-testid="createAccountLinkCompany" (click)="goToCompanyAccount()">
        Sou empresa
      </a>
      }
    </div>

    @if (!iaModeMobile.active()) {
    <aprova-stepper
      type="bullets"
      [steps]="steps"
      [currentStep]="currentStep"
      [showStepLabels]="true"
      [allowDirectNavigation]="false"
      (stepChange)="onStepChange($event)"
    />
    }

    @switch(currentStep) { @case(0) {
    <app-personal-form
      [blockedFields]="blockedFields"
      [cityConnection]="cityConnection"
      (setStepValidation)="setStepValidation(0, $event)"
      (onValidationError)="handleValidationError($event)"
      (onValidating)="handleValidatingState($event)"
    />
    } @case (1) {
    <app-address-form
      [hideRecaptcha]="hideRecaptcha"
      [blockedFields]="blockedFields"
      [isLastStep]="hidePasswordFields"
      [tenantCity]="cityEntity"
      (setStepValidation)="setStepValidation(1, $event)"
      (changeRecaptcha)="onChangeRecaptcha($event)"
    />
    } @case(2) {
    <app-account-form
      [hideRecaptcha]="hideRecaptcha"
      [extraFields]="extraFields"
      (setStepValidation)="setStepValidation(2, $event)"
      (changeRecaptcha)="onChangeRecaptcha($event)"
    />
    } }

    <div class="app-create-account__content__actions">
      <!-- No celular do IA mode o voltar fica só na seta do cabeçalho, como no design. -->
      @if (!iaModeMobile.active()) {
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--secondary"
        (click)="goToStep(currentStep - 1)"
      >
        Voltar
      </button>
      }
      <button
        type="button"
        class="app-create-account__btn app-create-account__btn--primary"
        [disabled]="!isCurrentStepValid || isValidatingCpfEmail()"
        (click)="goToNextStep()"
      >
        {{ currentStep === steps.length - 1 ? (iaModeMobile.active() ? 'Criar conta' : 'Finalizar') : 'Continuar' }}
      </button>
    </div>
  </div>
  } @else if (iaModeMobile.active() && sendConfirmationEmail()) {
  <!-- APR-4028 — "Confirme seu e-mail" do design. "Abrir e-mail" e "Trocar e-mail" ficaram de fora:
       não há link que abra a caixa de entrada em qualquer celular, e trocar o e-mail pede backend. -->
  <div class="app-create-account__verify" data-testid="createAccountMessageVerifyEmail">
    <div class="app-create-account__verify__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3 7 9 6 9-6" />
      </svg>
    </div>
    <h1 class="app-create-account__verify__title">Confirme seu e-mail</h1>
    <p class="app-create-account__verify__text">
      Enviamos um link para
      @if (createdEmail()) { <strong>{{ createdEmail() }}</strong>. } @else { o seu e-mail. }
      Toque nele para ativar sua conta e depois entre com seu e-mail e senha.
    </p>

    <button type="button" class="app-create-account__verify__primary" data-testid="createAccountButtonGoToLogin" (click)="redirectToLogin()">
      Ir para o login
    </button>
    @if (canResend() || resendState() === 'sent') {
    <button
      type="button"
      class="app-create-account__verify__secondary"
      data-testid="createAccountButtonResendEmail"
      [disabled]="!canResend() || resendState() === 'sending'"
      (click)="resendConfirmation()"
    >
      {{ resendState() === 'sent' ? 'E-mail reenviado' : resendState() === 'sending' ? 'Reenviando...' : 'Reenviar e-mail' }}
    </button>
    }
    @if (resendState() === 'recent') {
    <p class="app-create-account__verify__notice" data-testid="createAccountMessageResendRecent" role="status">
      Já enviamos o e-mail há pouco. Veja também a pasta de spam; um novo envio fica liberado em algumas horas.
    </p>
    } @else if (resendState() === 'error') {
    <p class="app-create-account__verify__notice app-create-account__verify__notice--error" data-testid="createAccountMessageResendError" role="alert">
      Não conseguimos reenviar agora. Tente de novo em alguns minutos.
    </p>
    }
  </div>
  } @else {
  <div class="app-create-account__success">
    <div class="app-create-account__success__icon">
      <aprova-icon
        name="check-circle-solid"
        size="lg"
        color="currentColor"
      />
    </div>
    <div class="app-create-account__success__content">
      <p class="app-create-account__success__title">
        Conta criada com sucesso!
      </p>
      @if (sendConfirmationEmail()) {

      <p class="app-create-account__success__subtitle">
        Enviamos um link de confirmação para o seu e-mail.<br>
        Acesse sua caixa de entrada e confirme a conta para liberar o acesso à Aprova.
      </p>
      <aprova-button
        buttonType="button"
        buttonClass="app-create-account__success__login__btn"
        label="Ir para o login"
        (click)="redirectToLogin()"
      />
      } @else {
      <p class="app-create-account__success__subtitle">
        Você será redirecionado para dentro do sistema em alguns segundos.
      </p>
      }
    </div>
  </div>
  }
</div>

<!-- Validation Error Modal -->
<aprova-validation-error-modal
  [isOpen]="showValidationErrorModal()"
  [errorData]="validationErrorData()"
  (onClose)="closeValidationErrorModal()"
  (onRetry)="retryAfterValidationError()"
/>
